import React from 'react'
import {Col, Divider, Input, Row, Space, Table} from "antd";
import SearchOutlined from "@ant-design/icons/es/icons/SearchOutlined";
import AppLabel from "./label";
import TabView from "./tabview";
import ProgressBar from "./progress_bar";
import {PROPOSALS_LIST} from "../constants/proposals";
import {withRouter} from "react-router-dom";

const ListItem=
    ({
    status,
    title,
    bottom,
    right,
        onClick
                })=>{
    return (
        <div
            className={'pointer highlight-hover'}>
        <Row justify={'space-between padding'}
             onClick={onClick}
        >
            <Col>
                <Space size={12}>
                    <AppLabel text={status} />
                    <div className={'font-lg bold'}>
                    {title}
                    </div>
                </Space>
                <br/>
                {
                    bottom
                }
            </Col>
            <Col>
                {
                    right
                }
            </Col>

        </Row>
            <Divider style={{margin:0}}/>
            </div>
    );
}

const AppList = withRouter(({
    title,
    header,
    items = PROPOSALS_LIST,
    render,
    ...props
})=>{

    var status = props.location.pathname.split('/')[2] || 'Pending';

    return (
        <div className={'list black-bg'}
             {...props}
        >
            {
                header
            }
            {
                items.map(item=>
                    (typeof render=='function')?render(item)
                        :
                    <ListItem
                    status={status}
                    title={item.title}
                    onClick={()=>{
                    props.history.push('/home/projects/923894632?status='+status)
                    }
                    }
                    bottom={<Space size={20}>
                        {item.owner_address}
                        <Space>Submitted at: <div className={'semibold'}>{item.submitted_date}</div></Space>
                    </Space>}
                    right={
                        <div className={'col right'}>
                            {item.votes} Votes
                            <br/>
                            <ProgressBar
                                percentage={item.percentage_completed}

                                label={'Completed'}
                            />
                        </div>
                    }
                />)
            }
        </div>
    )
})

export default withRouter(AppList)